import React from 'react';
import logout from '../Components/Image/logout.png'
import Sidebar from '../Components/Sidebar';
import { Table, InputGroup, FormControl } from 'react-bootstrap';
// Bootstrap CSS
import { Form } from 'react-bootstrap';

import "bootstrap/dist/css/bootstrap.min.css";
// To make rows collapsible
import "bootstrap/js/src/collapse.js";
import { useHistory, Link, Redirect } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


import { connect } from 'react-redux'
import { getQATemplates } from '../store/actions/qaTemplateActions'
import { getPODetails, getPOSearch, postPOLineItem, inspectionDashboard } from '../store/actions/poDetailsActions'
import { getDepartmentSearch } from '../store/actions/departmentActions'
import { getInspectionDetailsByInspectorID, getNewInspectionsByInspectorID, postWaiveOffInspection, postAcceptRejectInspection } from '../store/actions/inspectionActions'
import AuthHandlerInstance from '../Classes/AuthHandler'
import numberWithCommas from '../Classes/NumberwithComma'
import dateFormater from '../Classes/FormatDate'

import Modal from '../Components/CustomModal'
import ModalHeader from '../Components/ModalHeader'
import ModalBody from '../Components/ModalBody'
import ModalFooter from '../Components/ModalFooter'
import swal from '@sweetalert/with-react'


let MultipleCallIdData = []
class NewInspections extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Inspectiontabledata: [{ "item": "item1" }, { "item": "item2" }, { "item": "item3" }],
            multiCollapseIndex: '',
            modal: false,
            opacity: "",
            waiveOffModalData: [],
            comments: '',
            proposedDate: '',
            callId: '',
            InspectionId: '',
            checked: [],
            checkedAll: false,
            nextPlannedDate: ''
        }

        this.modal = this.modal.bind(this);
        this.handleRowClick = this.handleRowClick.bind(this);
        this.acceptInspection = this.acceptInspection.bind(this);
        this.acceptMultiInspection = this.acceptMultiInspection.bind(this);
        this.rejectInspection = this.rejectInspection.bind(this);
        this.comments = this.comments.bind(this);
        this.nextPlannedDate = this.nextPlannedDate.bind(this);
        this.handleSelectAll = this.handleSelectAll.bind(this);


    }

    comments(event) { this.setState({ comments: event.target.value }) }
    nextPlannedDate(event) { this.setState({ nextPlannedDate: event.target.value }) }


    modal() {
        this.setState({ modal: !this.state.modal, template: "", templatedata: [], customStageDropdown: false });
        if (this.state.modal == true) {
            this.setState({ opacity: "" })

        } else {
            // this.setState({ opacity: "0.2" })

        }
    }

    rejectPopup = async (InspectionId) => {
        await this.setState({ InspectionId: InspectionId })
        await this.modal()

    }

    handleRowClick = (index, value) => {
        console.log(index)
        var multiCollapseIndex = this.state.multiCollapseIndex

        if (multiCollapseIndex != index || multiCollapseIndex == '') {

            var proposedDate = value.proposedDate
            var callId = value.callId
            if (this.state.checked.length > 0) {

                console.log(";iuytfgcvbnm,w", callId)
            }
            this.setState({ multiCollapseIndex: index, proposedDate, callId })
        }
    }

    handleCheck = (index, e) => {
        let checked = [...this.state.checked]
        console.log(";iuytfgcvbnm,w1", checked)

        var flag_index = checked.includes(index)
        if (flag_index) {
            checked = checked.filter((item) => item !== index)
        } else {
            checked.push(index)
        }
        this.setState({ checked });
    }

    handleSelectAll = async () => {
        var checkedAll = !this.state.checkedAll;
        let checked = [...this.state.checked]
        await this.setState({ checkedAll: checkedAll });
        var inspectionDetailsByInspectorId = []
        await this.props.inspectionReducer.newCalls.map((value, index) => {
            value.LineItem.map((element, index) => {
                //console.log(element,'$$$$$$$')
                if (!element.HasAccepted) {
                    inspectionDetailsByInspectorId.push(element)
                }
            })
        })
        await inspectionDetailsByInspectorId.map((item, index) => {
            var flag_index = checked.includes(index)
            if (checkedAll) {
                if (!flag_index) {
                    checked.push(index)
                }
            } else {
                if (flag_index) {
                    checked = checked.filter((item) => item !== index)
                }
            }
        })
        this.setState({ checked });
    }

    waiveOff(callId) {
        this.props.postWaiveOffInspection(callId)
        this.modal()
    }



    componentDidMount() {
        var userId = AuthHandlerInstance.getUserID();
        this.props.getNewInspectionsByInspectorID(userId)
    }

    acceptInspection = async (InspectionId,callID) => {
        var userId = AuthHandlerInstance.getUserID()
        let body = {
            // InspectionCallLineItemId: poLineItemId,
            CallIdData: callID?callID: this.state.callId,
            InspectionId: InspectionId,
            inspectorId: userId,
            comments: '',
            rejectionReason: '',
            nextPlannedDate: null,
            hasAccepted: true,
            UserId: userId

        }
        await this.props.postAcceptRejectInspection(userId, InspectionId, body)

        this.props.getNewInspectionsByInspectorID(userId)
        this.setState({ multiCollapseIndex: '' })
    }

    acceptMultiInspection = async () => {
        var checked = this.state.checked
        if (checked.length == 0) {
            swal(`Please select the item to accept`);
            return false;
        }
        var userId = AuthHandlerInstance.getUserID()
        var inspectionDetailsByInspectorId = []
        await this.props.inspectionReducer.newCalls.map((value, index) => {
            value.LineItem.map((element, index) => {
                //console.log(element,'$$$$$$$')
                if (!element.HasAccepted) {
                    inspectionDetailsByInspectorId.push(element)
                }
            })
        })
        // for (var i = 0; i < checked.length; i++) {
        //     let body = {
        //         CallIdData:MultipleCallIdData.length>0 && this.state.checked.length>=MultipleCallIdData.length ? MultipleCallIdData:this.state.callId,
        //         InspectionCallLineItemId: inspectionDetailsByInspectorId[i].poLineItemId,
        //         InspectionAssignmentId: inspectionDetailsByInspectorId[i].InspectionAssignmentId,
        //         inspectorId: userId,
        //         inspectionCallId: inspectionDetailsByInspectorId[i].callId,
        //         comments: '',
        //         rejectionReason: '',
        //         nextPlannedDate: null,
        //         hasAccepted: true,
        //         UserId:userId

        //     }
        //     console.log("'poiytdfcbdasz",this.state.callId,body)

        //     await this.props.postAcceptRejectInspection(userId, inspectionDetailsByInspectorId[i].callId, body)
        // }
        console.log("MultipleCallIdData", MultipleCallIdData,checked)
        const checkedSet = new Set(checked);
        const checkedArray = [...checkedSet];
        let requestMap = {}; // create a map to store the callId and inspectorId combination that has already been sent

        for (var i = 0; i < checked.length; i++) {
          let callIds = MultipleCallIdData.length > 0 && this.state.checked.length >= MultipleCallIdData.length ? MultipleCallIdData : [this.state.callId];
          if ((MultipleCallIdData.some(item => item === inspectionDetailsByInspectorId[i].callId)) && callIds.length) {
            for (var j = 0; j < callIds.length; j++) {
              let combination = inspectionDetailsByInspectorId[i].callId + '-' + userId; // create a combination of callId and inspectorId
              if (!requestMap[combination]) { // check if the combination already exists in the map
                let body = {
                  CallIdData: callIds[j],
                  InspectionCallLineItemId: inspectionDetailsByInspectorId[i].poLineItemId,
                  InspectionAssignmentId: inspectionDetailsByInspectorId[i].InspectionAssignmentId,
                  inspectorId: userId,
                  inspectionCallId: inspectionDetailsByInspectorId[i].callId,
                  comments: '',
                  rejectionReason: '',
                  nextPlannedDate: null,
                  hasAccepted: true,
                  UserId: userId
                };
                await this.props.postAcceptRejectInspection(userId, inspectionDetailsByInspectorId[i].callId, body);
                requestMap[combination] = true; // add the combination to the map
              }
            }
          }
        }
        



        await this.props.getNewInspectionsByInspectorID(userId)
        await this.setState({ multiCollapseIndex: '', checked: [], checkedAll: false })
    }

    rejectInspection = async () => {
        var userId = AuthHandlerInstance.getUserID()
        let body = {
            inspectorId: userId,
            InspectionId: this.state.InspectionId,
            comments: '',
            rejectionReason: this.state.comments,
            nextPlannedDate: this.state.nextPlannedDate,
            hasAccepted: false,
            CallIdData: this.state.callId,
            UserId: userId

        }

        console.log("khjgfdcvbnm", this.state.callId, this.state.InspectionId, userId, body)
        // return false;

        await this.props.postAcceptRejectInspection(userId, this.state.InspectionId, body)

        await this.props.getNewInspectionsByInspectorID(userId)
        await this.setState({ multiCollapseIndex: '', InspectionId: '', comments: '', nextPlannedDate: '' })
        await this.modal()
    }

    render() {
        const { qaTemplate } = this.props.qaTemplate
        var inspectionDetailsByInspectorId = []
        //console.log(this.props.inspectionReducer.newCalls[0])
        this.props.inspectionReducer && this.props.inspectionReducer.newCalls.map((value, index) => {
            // value.LineItem.map((element,index) => {
            //     if(!element.HasAccepted){
            //         inspectionDetailsByInspectorId.push(element)
            //     }        
            // })
            if (!value.HasAccepted && value.InspectionStatus !== 'Inspection Request Rejected') {
                var exist = inspectionDetailsByInspectorId.findIndex((element) => element.InspectionId === value.InspectionId)
                if (exist === -1) {
                    inspectionDetailsByInspectorId.push(value)
                }
            }
        })
        //console.log(inspectionDetailsByInspectorId,'$$$$$$$')
        // this.props.inspectionReducer && this.props.inspectionReducer.newCalls.map((value,index) => {
        //     if(!value.HasAccepted){
        //         inspectionDetailsByInspectorId.push(value)
        //     }            
        // })
        console.log(inspectionDetailsByInspectorId)
        return (

            <div className="Container-fluid p-4" style={{ 'height': '100vh' }}>

                <Modal isOpen={this.state.modal}>

                    <ModalHeader HeaderStyle="modal-header">
                        <h4 style={{ color: 'black', textAlign: ' center', verticalAlign: 'middle' }}>Rejection Reason</h4>
                        <button type="button" className="close" aria-label="Close" onClick={this.modal} style={{ color: 'black' }}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </ModalHeader>
                    <ModalBody Style="modal-body modalbodys">
                        <div className="container p-4 ">

                            <div className="row text-center pb-4">
                                <FontAwesomeIcon icon='times-circle' className="submission-check-cirle" color='red' size="10x" />
                            </div>
                            <div className="row">
                                Reason Of Rejection

                                <div className="col  ">
                                    <textarea className="form-control" rows="2" value={this.state.comments} onChange={this.comments}></textarea>
                                </div>

                            </div>
                            <div className="row">
                                Next Planned Date

                                <div className="col  ">
                                    <Form.Group controlId="dob">
                                        <Form.Control type="date" name="dob" placeholder="Date" value={this.state.nextPlannedDate} onChange={this.nextPlannedDate} />
                                    </Form.Group>
                                </div>

                            </div>
                        </div>

                    </ModalBody>
                    <ModalFooter FooterStyle="modal-footer">
                        <div>
                            <button
                                type="button"
                                className="btn2 btn-sms1 rounded-pill mt-2 ml-4 float-left"
                                onClick={this.rejectInspection}
                            >
                                Reject
                            </button>
                            <button
                                type="button"
                                className="btn2 btn-sms1 rounded-pill mt-2 ml-4 float-right"
                                onClick={this.modal.bind(this)}
                            >
                                Cancel
                            </button>
                        </div>
                    </ModalFooter>


                </Modal>


                <div className="Container-fluid " style={{ opacity: this.state.opacity }}>
                    <div className="row">
                        <div className="col-md-8 header">
                            <b>New Inspections</b>
                        </div>
                        <div className="col-md-4 ">
                            <button className="btn2 btn-sms1 rounded-pill mt-2 mr-3 float-right" type="submit" onClick={this.acceptMultiInspection} > Accept </button>
                        </div>


                    </div>

                    <div className="row pl-2 pr-4">
                        <div className="col pr-4 centre-alligned">
                            <div className="row headerbar" >
                                <div className="col-md-1 pt-2 pb-2 borderheaderbar"><input
                                    type="checkbox" onChange={() => this.handleSelectAll()} checked={this.state.checkedAll} /></div>
                                <div className="col-md-1 pt-2 pb-2 borderheaderbar">Inspection No.</div>
                                <div className="col pt-2 pb-2 borderheaderbar">PO Number</div>
                                <div className="col pt-2 pb-2 borderheaderbar">Supplier Name</div>
                                <div className="col pt-2 pb-2 borderheaderbar ">Location</div>
                                <div className="col pt-2 pb-2 borderheaderbar ">Comments \ Remarks</div>
                                <div className="col-md-3 pt-2 pb-2 borderheaderbar">Action</div>
                            </div>
                            {
                                inspectionDetailsByInspectorId == '' ? <div className="row justify-content-center">No inspection calls found</div> : null
                            }

                            {
                                inspectionDetailsByInspectorId.map((value, index) => (
                                    <div>
                                        <div className={index % 2 == 0 ? 'row border ' : 'row  background '} onClick={() => this.handleRowClick(index, value)} data-toggle="collapse" data-target={`.multi-collapse${index}`}>
                                            <div className="col-md-1 pt-2 pb-2 text-center">
                                                <input
                                                    type="checkbox" checked={this.state.checked.includes(index)} onChange={(e) => { this.handleCheck(index, e) }}
                                                />
                                            </div>
                                            <div className="col-md-1 pt-2 pb-2 borderheaderbar">{value.InspectionId}</div>
                                            <div className="col pt-2 pb-2 borderheaderbar">{value.poNo}</div>
                                            <div className="col pt-2 pb-2 borderheaderbar ellipsis">{value.SupplierName}</div>
                                            <div className="col pt-2 pb-2 borderheaderbar ellipsis">{value.InspectionLocation ? value.InspectionLocation : value.Location}</div>
                                            <div className="col pt-2 pb-2 borderheaderbar">{value.Comments}</div>
                                            <div className="col-md-3 pt-2 pb-2 borderheaderbar ellipsis">
                                                <button className="btn2 btn-sms3 rounded-pill ml-2 float-right " type="submit" onClick={() => this.rejectPopup(value.InspectionId)} >Reject</button>
                                                <button className="btn2  btn-sms4 rounded-pill ml-4 float-right " type="submit" onClick={() => this.acceptInspection(value.InspectionId,value.callId)}>Accept</button>
                                            </div>

                                        </div>

                                        <div className={index == this.state.multiCollapseIndex ? `container collapse multi-collapse${index}` : `container collapse`}>
                                            {this.props.inspectionReducer.newCalls.map((el) => {
                                                if (el.InspectionId === value.InspectionId) {
                                                    if (MultipleCallIdData.length === 0) {
                                                        MultipleCallIdData.push(el.callId);
                                                    } else if (!MultipleCallIdData.some(item => item === el.callId)) {
                                                        MultipleCallIdData.push(el.callId);
                                                    }
                                                    console.log(";iuytfgcvbnm,w334", el, index, MultipleCallIdData)
                                                    return (
                                                        <>
                                                            <div className="row">
                                                                <div className="col-10 header pt-2"><b>Call ID : {el.callId}</b></div>
                                                            </div>
                                                            <div className="row  pl-2">
                                                                <div className="col pr-4">
                                                                    <div className="row headerbar" >
                                                                        <div className="col pt-2 pb-2 borderheaderbar">PO Number</div>
                                                                        <div className="col pt-2 pb-2 borderheaderbar">PO Line Item</div>
                                                                        <div className="col pt-2 pb-2 borderheaderbar">Stage \ Final</div>
                                                                        <div className="col pt-2 pb-2 borderheaderbar">Inspection Date</div>
                                                                        <div className="col pt-2 pb-2 borderheaderbar">QTY Offered</div>
                                                                    </div>
                                                                    {el.LineItem.map((item, index) => {
                                                                        return (
                                                                            <div className={el.HasWaivedOff ? 'row  backgroundwaiveOff' : index % 2 == 0 ? 'row border ' : 'row  background '} >
                                                                                <div className="col pt-2 pb-2 borderheaderbar">{item.poNo}</div>
                                                                                <div className="col pt-2 pb-2 borderheaderbar">{item.poLineItemNo}</div>
                                                                                <div className="col pt-2 pb-2 borderheaderbar">{item.CallItemType === 'RW' ? (<b>Rework</b>) : item.CallItemType === 'RV' ? (<b>Revisit</b>) : item.CallItemType === 'RJ' ? (<b>Rejected</b>) : ''} {(item.QATemplateStageId == 0 ? 'Final' : item.stageNameToInspect)} {(item.StageCounter ? " " + item.StageCounter : '')}</div>
                                                                                <div className="col pt-2 pb-2 borderheaderbar">{dateFormater(item.InspectionStartDate)}</div>
                                                                                <div className="col pt-2 pb-2 borderheaderbar">{item.inspectionQuantity}</div>
                                                                            </div>
                                                                        )
                                                                    })}
                                                                </div>
                                                            </div>
                                                        </>
                                                    )
                                                }
                                            })}

                                        </div>
                                    </div>
                                ))
                            }


                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({ qaTemplate: state.qaTemplate, poDetails: state.poDetails, departmentSearch: state.departmentSearchReducer, inspectionReducer: state.inspectionReducer })
export default connect(mapStateToProps, { getQATemplates, getPODetails, getDepartmentSearch, getPOSearch, inspectionDashboard, getInspectionDetailsByInspectorID, getNewInspectionsByInspectorID, postWaiveOffInspection, postAcceptRejectInspection })(NewInspections)
